import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "section" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "content has-text-centered" }
const _hoisted_4 = { class: "columns is-multiline" }
const _hoisted_5 = { class: "column is-half" }
const _hoisted_6 = { class: "card" }
const _hoisted_7 = { class: "card-content" }
const _hoisted_8 = { class: "media" }
const _hoisted_9 = { class: "media-left" }
const _hoisted_10 = { class: "image is-48x48" }
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 1,
  src: "https://bulma.io/images/placeholders/96x96.png",
  alt: "Placeholder image"
}
const _hoisted_13 = { class: "media-content" }
const _hoisted_14 = {
  key: 0,
  class: "title is-4"
}
const _hoisted_15 = {
  key: 1,
  class: "title is-4"
}
const _hoisted_16 = { class: "subtitle is-6" }
const _hoisted_17 = { class: "buttons" }
const _hoisted_18 = { class: "column is-half" }
const _hoisted_19 = { class: "buttons" }
const _hoisted_20 = { class: "buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_input = _resolveComponent("b-input")!
  const _component_b_field = _resolveComponent("b-field")!
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[16] || (_cache[16] = _createElementVNode("h1", { class: "title" }, "Firebase Auth Demo", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("figure", _hoisted_10, [
                      (_ctx.photoUrl)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _ctx.photoUrl
                          }, null, 8, _hoisted_11))
                        : (_openBlock(), _createElementBlock("img", _hoisted_12))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    (_ctx.name)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_ctx.name), 1))
                      : (_openBlock(), _createElementBlock("p", _hoisted_15, "User")),
                    _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.email), 1)
                  ])
                ])
              ])
            ]),
            _cache[9] || (_cache[9] = _createElementVNode("h2", { class: "title" }, "Update Profile", -1)),
            _createVNode(_component_b_field, { label: "Name" }, {
              default: _withCtx(() => [
                _createVNode(_component_b_input, {
                  type: "text",
                  modelValue: _ctx.input.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.input.name) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_b_field, { label: "Photo URL" }, {
              default: _withCtx(() => [
                _createVNode(_component_b_input, {
                  type: "url",
                  modelValue: _ctx.input.photoURL,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.input.photoURL) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("button", {
                class: "button is-link",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.update && _ctx.update(...args)))
              }, "Update")
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _cache[14] || (_cache[14] = _createElementVNode("h3", { class: "subtitle" }, "Link Your Account", -1)),
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_b_button, {
                disabled: _ctx.isLinkedGoogle,
                "icon-left": "google",
                "icon-pack": "fab",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.linkWithGoogle()))
              }, {
                default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                  _createTextVNode("Google", -1)
                ]))]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_component_b_button, {
                disabled: _ctx.isLinkedGithub,
                "icon-left": "github",
                "icon-pack": "fab",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.linkWithGithub()))
              }, {
                default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                  _createTextVNode("Github", -1)
                ]))]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_component_b_button, {
                disabled: _ctx.isLinkedFacebook,
                "icon-left": "facebook",
                "icon-pack": "fab",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.linkWithFacebook()))
              }, {
                default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                  _createTextVNode("Facebook", -1)
                ]))]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_component_b_button, {
                disabled: _ctx.isLinkedTwitter,
                "icon-left": "twitter",
                "icon-pack": "fab",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.linkWithTwitter()))
              }, {
                default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                  _createTextVNode("Twitter", -1)
                ]))]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _cache[15] || (_cache[15] = _createElementVNode("h4", { class: "subtitle" }, "Another Menu", -1)),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("button", {
                class: "button is-danger",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.deleteAccount && _ctx.deleteAccount(...args)))
              }, " Delete Account "),
              _createElementVNode("button", {
                class: "button is-warning",
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
              }, "Logout")
            ])
          ])
        ])
      ])
    ])
  ]))
}